<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onOverlayClick($event)">
    <div
      class="dialog-container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      [attr.aria-describedby]="descriptionId"
      cdkTrapFocus
      (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="dialog-header">
        <button
          class="back-button"
          type="button"
          [disabled]="submitting"
          [attr.aria-label]="t('lang.back')"
          (click)="onBack()">
          <mzic-svg src="assets/icons/arrow-left-disabled.svg" />
        </button>
        <h2 class="dialog-title" [id]="titleId">{{ t(currentTitleKey) }}</h2>
        <p class="dialog-subtitle" [id]="descriptionId">
          @if (step() === 'enter-cpf' && selectedRep(); as rep) {
            {{
              t('lang.business_rep_cpf_subtitle', {
                businessName: businessName,
              })
            }}
          } @else {
            {{ t('lang.business_rep_subtitle', { businessName: businessName }) }}
          }
        </p>
        <button
          class="close-button"
          [disabled]="submitting"
          (click)="onCancel()"
          type="button">
          <mzic-svg src="assets/icons/mzic-close.svg" />
        </button>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        @if (step() === 'enter-cpf' && selectedRep(); as rep) {
          <div class="rep-card selected cpf-rep-summary">
            <div class="card-radio">
              <span class="radio-outer">
                <span class="radio-inner"></span>
              </span>
            </div>
            <div class="rep-content">
              <h3 class="rep-name">{{ rep.name }}</h3>
              <p class="rep-role">{{ rep.role }}</p>
            </div>
          </div>

          <lib-waiver-cpf-field
            [control]="cpfControl"
            [sectionTitle]="t('lang.business_rep_cpf_section_title')"
            [label]="t('lang.cpf_input_label')"
            [placeholder]="t('lang.cpf_input_placeholder')"
            [invalidError]="t('lang.cpf_input_invalid_error')"
            [privacyInfo]="t('lang.business_rep_cpf_privacy_info')"
            [initialFocus]="true">
          </lib-waiver-cpf-field>
        } @else {
          <!-- Loading State with Shimmer -->
          @if (loading) {
            <div class="rep-list-shimmer">
              @for (item of shimmerItems; track item) {
                <div class="shimmer-card">
                  <div class="shimmer-radio"></div>
                  <div class="shimmer-content">
                    <div class="shimmer-name"></div>
                    <div class="shimmer-role"></div>
                  </div>
                </div>
              }
            </div>
          } @else {
            <!-- Representatives List -->
            <div class="rep-list">
              @for (rep of representatives; track rep.id) {
                <div
                  class="rep-card"
                  [class.selected]="selectedRep()?.id === rep.id"
                  (click)="selectRepresentative(rep)">
                  <div class="card-radio">
                    <span class="radio-outer">
                      <span class="radio-inner"></span>
                    </span>
                  </div>
                  <div class="rep-content">
                    <h3 class="rep-name">{{ rep.name }}</h3>
                    <p class="rep-role">{{ rep.role }}</p>
                    @if (rep.document_number) {
                      <p class="rep-document">{{ formatDocument(rep.document_number) }}</p>
                    }
                  </div>
                </div>
              } @empty {
                <div class="no-results">
                  <mzic-svg src="assets/icons/mzic-users.svg" class="no-results-icon" />
                  <p class="no-results-message">
                    {{ t('lang.business_rep_no_representatives') }}
                  </p>
                </div>
              }
            </div>
          }
        }
      </div>

      <!-- Footer -->
      <div class="dialog-footer">
        <button
          class="primary-button"
          [disabled]="!canConfirm"
          (click)="onConfirm()"
          type="button">
          @if (submitting) {
            <mzic-spinner />
          } @else {
            {{ t('lang.continue') | uppercase }}
          }
        </button>
      </div>
    </div>
  </div>
</ng-container>
